import { UsersManagementTable } from '../components';

const UsersManagement = () => {
  return <UsersManagementTable />;
};

export default UsersManagement;
